import { useEffect } from 'react';
import 'aos/dist/aos.css'; // Import AOS styles
import AOS from 'aos'; // Import AOS library
import "./ThirdSection.css";

export const ThirdSection = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration
      easing: 'ease-in-out', // Animation easing
      once: false, // Animation happens every scroll
    });
  }, []);

  return (
    <>
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-3" data-aos="fade-up">
            <div className="blog-card mb-4" style={{ height: '240px', border: 'none' }}>
              <a href="blogs/the-evolution-of-romantic-poetry">
                <picture>
                  <img className="img-fluid rounded" src="/media/blogs/the-evolution-of-romantic-poetry-from-then-to-now.jpg" alt=" The Evolution of Romantic Poetry: From Then to Now | Lone Wolf writes " style={{ height: '180px', width: '100%', objectFit: "cover" }} />
                </picture>
              </a>
              <div className="textarea">
                <a href="blogs/the-evolution-of-romantic-poetry" style={{ textDecoration: 'none', color: '#232323' }}>The Evolution of Romantic Poetry: From Then to Now</a>
              </div>
            </div>
          </div>
          <div className="col-md-3" data-aos="fade-up" data-aos-delay="200">
            <div className="blog-card mb-4" style={{ height: '240px', border: 'none'}}>
              <a href="blogs/poetry-as-therapy">
                <picture>
                  <img className="img-fluid rounded" src="/media/blogs/poetry-as-therapy-healing-through-words.jpg" alt=" Poetry as Therapy: Healing Through Words | Lone Wolf writes " style={{ height: '180px', width: '100%', objectFit: "cover" }} />
                </picture>
              </a>
              <div className="textarea">
                <a href="blogs/poetry-as-therapy" style={{ textDecoration: 'none', color: '#232323' }}>Poetry as Therapy: Healing Through Words</a>
              </div>
            </div>
          </div>
          <div className="col-md-3" data-aos="fade-up" data-aos-delay="400">
            <div className="blog-card mb-4" style={{ height: '240px', border: 'none' }}>
              <a href="blogs/top-10-timeless-poems">
                <picture>
                  <img className="img-fluid rounded" src="/media/blogs/top-ten-timeless-poems-that-resonate-across-generations.jpg" alt=" Top 10 Timeless Poems That Resonate Across Generations | Lone Wolf writes " style={{ height: '180px', width: '100%', objectFit: "cover" }} />
                </picture>
              </a>
              <div className="textarea">
                <a href="blogs/top-10-timeless-poems" style={{ textDecoration: 'none', color: '#232323' }}>Top 10 Timeless Poems That Resonate Across Generations</a>
              </div>
            </div>
          </div>
          <div className="col-md-3" data-aos="fade-up" data-aos-delay="600">
            <div className="blog-card mb-4" style={{ height: '240px', border: 'none' }}>
              <a href="blogs/the-power-of-words">
                <picture>
                  <img className="img-fluid rounded" src="/media/blogs/the-power-of-words-how-a-simple-quote-can-change-your-day.jpg" alt=" The Power of Words: How a Simple Quote Can Change Your Day | Lone Wolf writes " style={{ height: '180px', width: '100%', objectFit: "cover" }} />
                </picture>
              </a>
              <div className="textarea">
                <a href="blogs/the-power-of-words" style={{ textDecoration: 'none', color: '#232323' }}>The Power of Words: How a Simple Quote Can Change Your Day</a>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-3" data-aos="zoom-in">
            <div className="blog-card mb-4" style={{ height: '240px', border: 'none' }}>
              <a href="blogs/inspirational-quotes-for-every-stage">
                <picture>
                  <img className="img-fluid rounded" src="/media/blogs/inspirational-quotes-for-every-stage-of-life.jpg" alt=" Inspirational Quotes for Every Stage of Life | Lone Wolf writes " style={{ height: '180px', width: '100%', objectFit: "cover" }} />
                </picture>
              </a>
              <div className="textarea">
                <a href="blogs/inspirational-quotes-for-every-stage" style={{ textDecoration: 'none', color: '#232323' }}>Inspirational Quotes for Every Stage of Life</a>
              </div>
            </div>
          </div>
          <div className="col-md-3" data-aos="zoom-in" data-aos-delay="200">
            <div className="blog-card mb-4" style={{ height: '240px', border: 'none' }}>
              <a href="blogs/from-thoughts-to-verse">
                <picture>
                  <img className="img-fluid rounded" src="/media/blogs/from-thought-to-verse-a-beginner’s-guide-to-writing-poetry.jpg" alt=" From Thought to Verse: A Beginner’s Guide to Writing Poetry | Lone Wolf writes " style={{ height: '180px', width: '100%', objectFit: "cover" }} />
                </picture>
              </a>
              <div className="textarea">
                <a href="blogs/from-thoughts-to-verse" style={{ textDecoration: 'none', color: '#232323' }}>From Thought to Verse: A Beginner’s Guide to Writing Poetry</a>
              </div>
            </div>
          </div>
          <div className="col-md-3" data-aos="zoom-in" data-aos-delay="400">
            <div className="blog-card mb-4" style={{ height: '240px', border: 'none' }}>
              <a href="blogs/craft-quotes-that-speak-volumes">
                <picture>
                  <img className="img-fluid rounded" src="/media/blogs/how-to-craft-quotes-that-speak-volumes.jpg" alt=" How to Craft Quotes That Speak Volumes | Lone Wolf writes " style={{ height: '180px', width: '100%', objectFit: "cover" }} />
                </picture>
              </a>
              <div className="textarea">
                <a href="blogs/craft-quotes-that-speak-volumes" style={{ textDecoration: 'none', color: '#232323' }}>How to Craft Quotes That Speak Volumes</a>
              </div>
            </div>
          </div>
          <div className="col-md-3" data-aos="zoom-in" data-aos-delay="600">
            <div className="blog-card mb-4" style={{ height: '240px', border: 'none' }}>
              <a href="blogs/creative-ways-to-display-quotes">
                <picture>
                  <img className="img-fluid rounded" src="/media/blogs/famous-poets-and-the-stories-behind-their-masterpieces.jpg" alt=" Creative Ways to Display Quotes in Your Home or Office | Lone Wolf writes " style={{ height: '180px', width: '100%', objectFit: "cover" }} />
                </picture>
              </a>
              <div className="textarea">
                <a href="blogs/creative-ways-to-display-quotes" style={{ textDecoration: 'none', color: '#232323' }}>Creative Ways to Display Quotes in Your Home or Office</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
